import React from 'react';
import clsx from 'clsx';

const colorMap = {
  default: 'chip-default',
  primary: 'chip-primary',
  success: 'chip-success',
  warning: 'chip-warning',
  error: 'chip-error',
  neutral: 'chip-neutral',
  info: 'chip-info',
};

export function Chip({ children, color = 'default', className, onClick, ...props }) {
  const Component = onClick ? 'button' : 'span';
  return (
    <Component
      className={clsx('chip', colorMap[color], onClick && 'cursor-pointer hover:opacity-80', className)}
      onClick={onClick}
      {...props}
    >
      {children}
    </Component>
  );
}

// Status-specific chips
const statusColorMap = {
  draft: 'warning',
  sent: 'primary',
  accepted: 'success',
  converted: 'primary',
  changes_requested: 'warning',
  active: 'success',
  in_progress: 'primary',
  partially_scheduled: 'primary',
  scheduled: 'warning',
  completed: 'success',
  paid: 'success',
  cancelled: 'error',
  new: 'primary',
  contacted: 'warning',
  qualified: 'success',
  lost: 'error',
  expired: 'default',
  hot: 'error',
  won: 'success',
  acknowledged: 'success',
  acknowledged_pending: 'warning',
  declined: 'error',
  overdue: 'error',
  not_scheduled: 'warning',
  viewed: 'primary',
};

export function StatusChip({ status, className, config }) {
  // If config provided, use it for label and color mapping
  if (config && config[status]) {
    const { label, color } = config[status];
    const chipColor = color === 'green' ? 'success' : color === 'red' ? 'error' : color === 'yellow' ? 'warning' : color === 'gray' ? 'default' : color === 'blue' ? 'primary' : 'default';
    return <Chip color={chipColor} className={className}>{label}</Chip>;
  }
  const color = statusColorMap[status] || 'default';
  const label = status?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || 'Unknown';
  return <Chip color={color} className={className}>{label}</Chip>;
}
